import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCalendarCellClassFunction, MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { MatRadioModule } from '@angular/material/radio';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ReservationPayload } from '../../../core/interfaces/reservation-payload.interface';
import { ReservationService } from '../../../core/services/reservation.service';
import { cpfValidator } from '../../../core/util/cpf-validator';
import { extendedEmailValidator } from '../../../core/util/email-validator';
import { PhoneCountryInputComponent } from '../phone-country-input/phone-country-input.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AppTranslateService } from '../../../core/services/translate.service';

@Component({
  selector: 'madero-modal-reservation',
  imports: [
    CommonModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatIconModule,
    MatCheckboxModule,
    MatTabsModule,
    MatMenuModule,
    NgxMaskDirective,
    MatProgressSpinnerModule,
    MatRadioModule,
    PhoneCountryInputComponent,
    TranslatePipe,
  ],
  providers: [
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    provideNgxMask(),
  ],
  templateUrl: './modal-reservation.component.html',
  styleUrl: './modal-reservation.component.scss',
})
export class ModalReservationComponent implements OnInit {
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;

  loadingCpf = false;
  currentLanguage = signal<string>('pt');

  utmId = signal<string | null>(null);
  customUrlId = signal<string>(''); // NOTRACKING | HOMEPAGE | ID

  isUniqueStore = false;
  hidePanels = false;

  formreserve!: FormGroup;
  form!: FormGroup;
  step = 0;
  indexTab = 0;

  disableAccordion = [false, true, true, true, true, true];

  listState: any[] = [];
  selectedState: string = '';

  listCity: any[] = [];
  selectedCity: string = '';

  listStore: any[] = [];
  selectedStore: string = '';
  selectedBranchId = '';
  branchTolerance = 0;
  isDocumentMandatory = true;

  showPanelHall = true;
  listHall: any[] = [];
  selectedHall: string = '';
  selectedHallId = '';

  listPeoples: any[] = [];
  selectedPeoples: number = 0;

  selectedDay: any = '';
  minDate: Date = new Date();
  maxDate: Date = new Date();
  blockDays: string[] = [];
  availableSpacesByDay: WritableSignal<{ [weekDay: number]: number }> = signal({});

  listHour: any[] = [];
  selectedHour: string = '';

  listOcasions: any[] = [];

  loaderState = false;
  loaderCity = false;
  loaderStore = false;
  loaderHall = false;
  loaderPeoples = false;
  loaderDay = false;
  loaderHour = false;

  bodyReservation: ReservationPayload = {
    branchId: '',
    hallId: '',
    quantity: 0,
    date: '',
    hour: '',
    cpf: '',
    name: '',
    email: '',
    phone: '',
    occasion: 0,
    birthday: '',
    observation: '',
    allowAdd: true,
    newCustomer: null,
    bookingOrigin: '',
    actor: '',
    isCashbackClient: false,
    customUrlId: '',
  };
  cpfIsCashBack = false;

  loading = false;
  notFound = false;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private reservationService: ReservationService,
    private router: Router,
    private snackBar: MatSnackBar,
    private appTranslateService: AppTranslateService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.onGetOcasions();
    this.onBuildFormReserve();
    this.onBuildForm();
    this.onGetAllStates();

    this.isUniqueStore = this.router.url.split('/').length > 2;

    if (this.isUniqueStore) {
      this.hidePanels = true;
      this.onLoadBranch();
    } else {
      this.customUrlId.set('HOMEPAGE');
      console.log('type URL: ', this.customUrlId());
    }
  }

  changeLanguage(lang: string): void {
    this.appTranslateService.changeLanguage(lang);
    this.currentLanguage.set(lang);
  }

  onClearSteps(stepCurrent: number, item?: string): void {
    const resetCity = () => {
      this.listCity = [];
      this.selectedCity = '';
      this.formreserve.get('city')?.reset();
    };

    const resetStore = () => {
      this.listStore = [];
      this.selectedStore = '';
      this.selectedBranchId = '';
      this.branchTolerance = 0;
      this.formreserve.get('store')?.reset();
      this.disableAccordion[1] = true;
    };

    const resetHall = () => {
      this.showPanelHall = true;
      this.listHall = [];
      this.selectedHall = '';
      this.selectedHallId = '';
      this.formreserve.get('hall')?.reset();
      this.disableAccordion[2] = true;
    };

    const resetPeoples = () => {
      this.listPeoples = [];
      this.selectedPeoples = 0;
      this.formreserve.get('peoples')?.reset();
      this.disableAccordion[3] = true;
    };

    const resetDay = () => {
      this.selectedDay = '';
      this.blockDays = [];
      this.formreserve.get('day')?.reset();
      this.disableAccordion[4] = true;
    };

    const resetHour = () => {
      this.listHour = [];
      this.selectedHour = '';
      this.formreserve.get('hour')?.reset();
      this.disableAccordion[5] = true;
    };

    switch (stepCurrent) {
      case 0:
        if (item === 'state') {
          resetCity();
        }
        resetStore();
        resetHall();
        resetPeoples();
        resetDay();
        resetHour();
        break;
      case 1:
        resetHall();
        resetPeoples();
        resetDay();
        resetHour();
        break;
      case 2:
        resetPeoples();
        resetDay();
        resetHour();
        break;
      case 3:
        resetDay();
        resetHour();
        break;
      case 4:
        resetHour();
        break;
      default:
        break;
    }
  }

  onLoadBranch(): void {
    const id = this.router.url.split('/')[this.router.url.split('/').length - 1];

    // Verificar se a url contem utm e capturar utmId. utilizado em campanha externas
    if (id.indexOf('?') !== -1) {
      this.selectedBranchId = id.split('?')[0]; // pegou branchID da url

      // captura utmId
      this.customUrlId.set(this.router.url.split('?utm=')[1]);
    } else {
      // verificar se existe campanha para essa filial vinda do site Madero
      this.selectedBranchId = id;
      this.customUrlId.set('NOTRACKING');
      console.log('type URL: ', this.customUrlId());
    }

    this.reservationService.getBranchById(this.selectedBranchId).subscribe({
      next: (branch) => {
        this.selectedStore = branch.nickName;
        this.branchTolerance = branch.tolerance;
        this.isDocumentMandatory = branch.isDocumentMandatory;
        this.updateCPFValidators();
      },
      error: (err) => {
        this.notFound = true;
      },
    });

    this.removeValidation();
    this.formreserve.get('hall')?.enable();
    this.disableAccordion[2] = false;
    this.onGetHallByBranchs(this.selectedBranchId);
    this.bodyReservation.branchId = this.selectedBranchId;
  }

  removeValidation() {
    this.formreserve.get('state')?.clearValidators();
    this.formreserve.get('state')?.updateValueAndValidity();
    this.formreserve.get('city')?.clearValidators();
    this.formreserve.get('city')?.updateValueAndValidity();
    this.formreserve.get('store')?.clearValidators();
    this.formreserve.get('store')?.updateValueAndValidity();
  }

  dateFilter = (date: Date | null): boolean => {
    if (!date) return false;

    return (
      this.isDateBlocked(date) === false &&
      this.isDateAvailableByPlaces(date) &&
      date >= this.minDate &&
      date <= this.maxDate
    );
  };

  private isDateAvailableByPlaces(date: Date): boolean {
    return this.availableSpacesByDay()[date.getDay()] >= this.selectedPeoples;
  }

  private isDateBlocked(date: Date): boolean {
    const dayString = date.toISOString().split('T')[0];
    return this.blockDays?.includes(dayString);
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if (view === 'month') {
      if (cellDate < new Date()) return '';

      if (this.isDateAvailableByPlaces(cellDate) === false) return 'tooltip-date no-place';
    }

    return '';
  };

  onBuildFormReserve(): void {
    this.formreserve = this.fb.group({
      state: new FormControl({ value: null, disabled: false }, Validators.required),
      city: new FormControl({ value: null, disabled: true }, Validators.required),
      store: new FormControl({ value: null, disabled: true }, Validators.required),
      day: new FormControl({ value: null, disabled: true }, Validators.required),
      hall: new FormControl({ value: null, disabled: true }, Validators.required),
      peoples: new FormControl({ value: null, disabled: true }, Validators.required),
      hour: new FormControl({ value: null, disabled: true }, Validators.required),
    });
  }

  onBuildForm(): void {
    this.form = this.fb.group({
      cpf: ['', [Validators.required, cpfValidator]],
      name: ['', Validators.required],
      mail: ['', [Validators.required, Validators.email, extendedEmailValidator()]],
      phone: ['', Validators.required],
      occasion: [10, Validators.required],
      observation: ['', Validators.maxLength(100)],
      marketing: [false, Validators.required],
      newCustomer: [null, Validators.required],
      birthday: ['', [Validators.required, this.dateRangeValidator(16, 130)]],
    });
  }

  updateCPFValidators(): void {
    const cpfControl = this.form.get('cpf');
    if (!cpfControl) return;

    if (this.isDocumentMandatory) {
      cpfControl.setValidators([Validators.required, cpfValidator]);
    } else {
      cpfControl.clearValidators();
      cpfControl.setValue('');
    }
    cpfControl.updateValueAndValidity();
  }

  onClose(): void {
    this.dialogRef.close(this.data);
  }

  range(n: number) {
    const result = [];
    for (let i = 1; i < n; i++) {
      result.push(i);
    }
    return result;
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    if (this.step == 1) {
      !this.showPanelHall ? this.step++ : false;
    }
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  prevTab() {
    this.indexTab--;
    this.tabGroup.selectedIndex = this.indexTab;
  }
  goToSpecificTab(index: number) {
    this.tabGroup.selectedIndex = index;
  }

  onGoNext(index: number): void {
    if (this.indexTab == 0) {
      this.indexTab = index;
      this.tabGroup.selectedIndex = this.indexTab;
    } else {
      this.onSubmit();
    }
  }

  onValidateForms(): boolean {
    if (this.indexTab == 0) {
      return this.formreserve.valid;
    } else {
      return this.form.valid;
    }
  }

  onBlur(event: FocusEvent): void {
    const cpfControl = this.form.get('cpf');
    const cpf = cpfControl?.value;

    if (!this.isDocumentMandatory) {
      return;
    }

    if (cpfControl?.valid && cpf) {
      this.loadingCpf = true;
      this.reservationService.verifyCPF(cpf).subscribe({
        next: (userCash) => {
          this.cpfIsCashBack = true;
          this.form.patchValue({
            name: userCash.name,
            phone: userCash.phone,
            birthday: this.formatDatePtBR(userCash.birthday),
          });
        },
        error: (err) => {
          this.cpfIsCashBack = false;
        },
        complete: () => {
          this.loadingCpf = false;
        },
      });
    }
  }

  formatDatePtBR(dateString: string): string {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  }

  /*Services */
  onGetOcasions(): void {
    this.reservationService.getOcasion().subscribe({
      next: (ocasion) => {
        this.listOcasions = ocasion;
      },
    });
  }

  onGetAllStates(): void {
    this.loaderState = true;
    this.reservationService.getAllStates().subscribe({
      next: (states) => {
        this.listState = states;
        this.loaderState = false;
      },
      error: (err) => {
        this.loaderState = false;
      },
    });
  }

  onGetCityByState(acronymState: string): void {
    this.loaderCity = true;
    this.reservationService.getCitiesByState(acronymState).subscribe({
      next: (cities) => {
        this.listCity = cities;
        this.loaderCity = false;
      },
      error: (err) => {
        this.loaderCity = false;
      },
    });
  }

  onGetBranchsByCity(city: string): void {
    this.loaderStore = true;
    this.reservationService.getBranchesByCity(city).subscribe({
      next: (branchs) => {
        this.listStore = branchs;
        this.loaderStore = false;
      },
      error: (err) => {
        this.loaderStore = false;
      },
    });
  }

  onGetHallByBranchs(branchId: string): void {
    this.loaderHall = true;
    this.reservationService.getHallByBranch(branchId).subscribe({
      next: (halls) => {
        this.listHall = halls;
        if (this.listHall.length > 1) {
          this.showPanelHall = true;
        } else {
          this.showPanelHall = false;
          this.selectedHallId = this.listHall[0].id;
          this.selectedHall = this.listHall[0].hallName;
          this.bindAvailablePlaceDays(this.selectedBranchId, this.selectedHallId);

          this.formreserve.get('peoples')?.enable();
          this.disableAccordion[3] = false;
          this.onGetPeoples(this.selectedHallId, this.selectedBranchId);
          this.bodyReservation.hallId = this.selectedHallId;

          this.formreserve.get('hall')?.clearValidators();
          this.formreserve.get('hall')?.updateValueAndValidity();
        }
        this.loaderHall = false;
      },
      error: (err) => {
        this.loaderHall = false;
      },
    });
  }

  onGetPeoples(hallId: string, branchId: string): void {
    this.loaderPeoples = true;
    this.reservationService.getPeoples(hallId, branchId).subscribe({
      next: (peoples) => {
        this.listPeoples = peoples.places;
        this.loaderPeoples = false;
      },
      error: (err) => {
        this.loaderPeoples = false;
      },
    });
  }

  onGetDates(hallId: string, branchId: string, quantity: number): void {
    this.loaderDay = true;
    this.reservationService.getDates(hallId, branchId, quantity).subscribe({
      next: (dates) => {
        this.minDate = new Date(dates.dateMin);
        this.maxDate = new Date(dates.dateMax);
        this.blockDays = dates.blockDays;
        this.loaderDay = false;
      },
      error: (err) => {
        this.loaderDay = false;
      },
    });
  }

  onGetHour(hallId: string, branchId: string, quantity: number, day: string): void {
    this.loaderHour = false;
    this.reservationService.getHour(hallId, branchId, quantity, day).subscribe({
      next: (hour) => {
        this.listHour = hour;
        this.loaderHour = false;
      },
      error: (err) => {
        this.loaderHour = false;
      },
    });
  }

  /*Selects*/
  onCheckDisable(formControlName: string): boolean {
    const valid = this.formreserve.get(formControlName)?.hasError('required') ? true : false;
    return valid;
  }

  onSelectState(event: any): void {
    this.onClearSteps(this.step, 'state');
    this.selectedState = event.value;
    if (event.value) {
      this.formreserve.get('city')?.enable();
      this.onGetCityByState(event.value);
    } else {
      this.formreserve.get('city')?.disable();
    }
  }

  onSelectCity(event: any): void {
    this.onClearSteps(this.step, 'city');
    this.selectedCity = event.value?.name;
    if (event.value) {
      this.formreserve.get('store')?.enable();
      this.disableAccordion[1] = false;
      this.onGetBranchsByCity(event.value.name);
    } else {
      this.formreserve.get('store')?.disable();
      this.disableAccordion[1] = true;
    }
  }

  onSelectStore(event: any): void {
    this.onClearSteps(this.step);
    this.selectedStore = event.value?.nickName;
    this.selectedBranchId = event.value?.id;
    this.isDocumentMandatory = event.value?.isDocumentMandatory;
    this.updateCPFValidators();
    if (event.value) {
      this.formreserve.get('hall')?.enable();
      this.disableAccordion[2] = false;
      this.onGetHallByBranchs(event.value?.id);
      this.bodyReservation.branchId = this.selectedBranchId;
      this.branchTolerance = event.value?.tolerance;
    } else {
      this.formreserve.get('hall')?.disable();
      this.disableAccordion[2] = true;
    }
  }

  bindAvailablePlaceDays(branchId: string, hallId: string): void {
    this.reservationService
      .getAvailablePlacesByDay(branchId, hallId)
      .subscribe((res) => this.availableSpacesByDay.set(res));
  }

  onSelectHall(event: any): void {
    this.onClearSteps(this.step);
    this.selectedHall = event.value?.hallName;
    this.selectedHallId = event.value?.id;
    if (event.value) {
      this.formreserve.get('peoples')?.enable();
      this.disableAccordion[3] = false;
      this.onGetPeoples(event.value?.id, this.selectedBranchId);
      this.bindAvailablePlaceDays(this.selectedBranchId, this.selectedHallId);
      this.bodyReservation.hallId = this.selectedHallId;
    } else {
      this.formreserve.get('peoples')?.disable();
      this.disableAccordion[3] = true;
    }
  }

  onSelectPeople(event: any): void {
    this.onClearSteps(this.step);
    this.selectedPeoples = event.value;
    if (event.value) {
      this.formreserve.get('day')?.enable();
      this.disableAccordion[4] = false;
      this.onGetDates(this.selectedHallId, this.selectedBranchId, this.selectedPeoples);
      this.bodyReservation.quantity = this.selectedPeoples;
    } else {
      this.formreserve.get('day')?.disable();
      this.disableAccordion[4] = true;
    }
  }

  onSelectDay(event: any): void {
    this.onClearSteps(this.step);
    this.selectedDay = event.value;
    // let formattedDate = this.selectedDay.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
    let day = this.selectedDay.getDate();
    let month = this.selectedDay.getMonth() + 1;
    let year = this.selectedDay.getFullYear();
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    let formattedDate = `${month}/${day}/${year}`;

    if (event.value) {
      this.formreserve.get('hour')?.enable();
      this.disableAccordion[5] = false;
      this.onGetHour(this.selectedHallId, this.selectedBranchId, this.selectedPeoples, formattedDate);
      this.bodyReservation.date = formattedDate;
    } else {
      this.formreserve.get('hour')?.disable();
      this.disableAccordion[5] = true;
    }
  }

  onSelectHour(event: any): void {
    this.onClearSteps(this.step);
    this.selectedHour = event.value;
    if (event.value) {
      this.bodyReservation.hour = this.selectedHour;
    } else {
    }
  }

  onSubmit(): void {
    this.loading = true;
    const formValues = this.form.value;
    const selectedDate = new Date(this.selectedDay);
    const formattedDate = selectedDate.toISOString().split('T')[0];

    if (this.form.valid) {
      const bodyReservation: ReservationPayload = {
        branchId: this.selectedBranchId,
        hallId: this.selectedHallId,
        quantity: this.selectedPeoples,
        date: formattedDate,
        hour: this.selectedHour,
        cpf: formValues.cpf,
        name: formValues.name.replace(/\s{2,}/g, ' ').trim(), // remove espacos entre e depois do nome
        email: formValues.mail,
        phone: formValues.phone.substring(1),
        occasion: parseInt(formValues.occasion),
        birthday: this.formatBirthday(formValues.birthday),
        observation: formValues.observation,
        allowAdd: formValues.marketing,
        newCustomer: formValues.newCustomer != '0',
        bookingOrigin: 'DefaultForm',
        actor: 'Consumer',
        isCashbackClient: this.cpfIsCashBack,
        customUrlId: this.customUrlId(),
      };

      this.bodyReservation = bodyReservation;

      this.reservationService.createReservation(bodyReservation).subscribe({
        next: (value) => {
          this.loading = false;
          this.indexTab++;
          this.tabGroup.selectedIndex = this.indexTab;
        },
        error: (err) => {
          this.loading = false;
          this.snackBar.open('Ocorreu um erro ao registrar a reserva.', 'fechar', { duration: 5000 });
        },
      });
    } else {
      console.log('Por favor, preencha todos os campos obrigatórios.', formValues);
      this.loading = false;
    }
  }

  formatBirthday(birthday: string): string {
    const day = birthday.substring(0, 2);
    const month = birthday.substring(2, 4);
    const year = birthday.substring(4, 8);
    const date = new Date(`${year}-${month}-${day}`);
    const formattedDate = date.toISOString().split('T')[0];
    return formattedDate;
  }

  dateRangeValidator(minAge: number, maxAge: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return { required: true };
      }

      const day = parseInt(value.slice(0, 2), 10);
      const month = parseInt(value.slice(2, 4), 10) - 1; // -1 para ajustar para 0-11 no objeto Date
      const year = parseInt(value.slice(4), 10);

      const birthDate = new Date(year, month, day);
      const age = this.calculateAge(birthDate);

      // Verificar se a data é válida
      const maxDaysInMonth = this.getMaxDaysInMonth(month + 1, year);

      if (day < 1 || day > maxDaysInMonth) {
        return { invalidDayOfMonth: true };
      }

      if (month < 0 || month > 11) {
        return { invalidMonth: true };
      }

      if (isNaN(age) || age < minAge || age > maxAge) {
        return { invalidAgeRange: true };
      }

      return null;
    };
  }

  calculateAge(birthDate: Date): number {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  getMaxDaysInMonth(month: number, year: number): number {
    // Ajustando para que o mês seja fornecido como 0-11
    const adjustedMonth = month - 1;
    if (adjustedMonth === 1) {
      // Fevereiro
      return this.isLeapYear(year) ? 29 : 28;
    } else {
      return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][adjustedMonth];
    }
  }

  isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }
}
